import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { Input, Textarea } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import DirectUploader from 'modules/trainings/components/Files/Uploaders/DirectUploader'
import { ContentEditorProps } from 'modules/trainings/components/content/types'
import { AttachedFile } from 'modules/trainings/lib/content/AttachedFile'
import { ContentModule } from 'modules/trainings/lib/content/Module'

const ModuleEditor = observer(({ contentItem, trainingId }: ContentEditorProps<ContentModule>) => {
  const initialFile = contentItem.thumbnail
    ? contentItem.thumbnail.toFileObject('image/jpeg')
    : undefined

  return (
    <>
      <Input
        label={i18n.t('trainings.content.module_modal.label_title')}
        onChange={(value: string) => {
          contentItem.title = value
        }}
        placeholder={i18n.t('trainings.content.module_modal.label_placeholder')}
        value={contentItem.title}
        required
      />
      <Textarea
        label={i18n.t('trainings.content.module_modal.description_title')}
        onChange={(value: string) => {
          contentItem.description = value
        }}
        placeholder={i18n.t('trainings.content.module_modal.description_placeholder')}
        value={contentItem.description || ''}
      />

      <Box className="gap-2">
        <Box className="gap-1">
          <label className="font-medium text-f1-foreground-secondary">
            {i18n.t('trainings.content.module_modal.upload_label')}
          </label>
          <span className="text-base text-f1-foreground-secondary">
            {i18n.t('trainings.content.module_modal.upload_description')}
          </span>
        </Box>
        <DirectUploader
          onUpload={async (uploadData) => {
            contentItem.thumbnail = AttachedFile.fromUpload(
              uploadData.file,
              uploadData.signedId || ''
            )
          }}
          onDelete={() => {
            contentItem.thumbnail = undefined
          }}
          description={'Upload .jpeg, .png, or .mov files up to 10MB.'}
          fileTypes={['image' as const]}
          resourceType={'Trainings::Training'}
          resourceId={String(trainingId)}
          initialFile={initialFile}
        />
      </Box>
    </>
  )
})

export { ModuleEditor }
